module.exports = __webpack_public_path__ + "img/img_3dfield_powerflow_s.1c5bb966.svg";